import { useMetadataHistoryStore } from "../../stores/metadata-history-store";
import { useHistoryStore } from "../../stores/history-store";
import { builderSessionId, useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import type { MetadataEventPayload } from "./metadata-events";
import { builderDayLayoutMode, moveDayLayout } from "../metadata-builder/day-layouts";
import { moveSharedDayDate, getBuilderDateAnchors } from "../metadata-builder/day-date-layout";
import { weekdayKeys } from "../schedule-time/schedule-dates";

export function dispatchMetadataEvent(payload: MetadataEventPayload, mergeKey?: string) {
  let event = structuredClone(payload);
  if (event.type === "position/set") event.point = event.point.map(Math.round);
  const active = useMetadataBuilderStore.getState().active;
  const sessionId = active ? builderSessionId : useMetadataHistoryStore.getState().activeId;
  if (active && event.type === "position/set") {
    const session = useMetadataHistoryStore.getState().sessions[builderSessionId];
    const mode = builderDayLayoutMode(useMetadataBuilderStore.getState().step);
    const layout = mode ? session?.dayLayouts?.[mode] : undefined;
    const dateDay = weekdayKeys.find(day => event.type === "position/set" && event.path === `days.${day}.date`);
    const dateAnchors = dateDay ? getBuilderDateAnchors() : null;
    if (session && dateAnchors && dateDay) {
      event = moveSharedDayDate(session.projection, dateAnchors, dateDay, event.point);
    } else if (session && layout) {
      const moved = moveDayLayout(session.projection, layout, event.path, event.point);
      if (moved) event = { type: "day-layout/set", ...moved, styles: {} };
    }
  }
  useHistoryStore.getState().appendMetadata(sessionId, {
    ...event, id: crypto.randomUUID(), at: Date.now(), mergeKey,
  });
}

export function endMetadataMerge() {
  useHistoryStore.getState().sealMerge();
}
